import { render, staticRenderFns } from "./PublishTemplateModal.vue?vue&type=template&id=2022a6f8"
import script from "./PublishTemplateModal.vue?vue&type=script&lang=js"
export * from "./PublishTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./PublishTemplateModal.vue?vue&type=style&index=0&id=2022a6f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports